import { useApi } from '@/api';
import { IconKpiCard, KpiSkeleton, Link } from '@/components';
import FarmsIcon from '@/components/icons/Farms';
import { Flex, LinkWrapper, PercentageValue } from '@blockanalitica/ui';

export default function FarmKpi({ days_ago }) {
  const [data, error] = useApi({
    url: '/farms/aggregated/',
    queryParams: {
      days_ago: days_ago
    }
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <LinkWrapper
        to="/rewards"
        // @ts-ignore
        as={Link}
        variant="kpiCardLinkWithBlendMode">
        <IconKpiCard
          leftIcon={<FarmsIcon size="6" />}
          title="Rewards TVL"
          titleRight={
            <Flex fontSize="1" color="muted" alignItems="center" gap="3xs">
              APY:
              <Flex gap="2xs" color="white">
                <PercentageValue
                  value={data.apy}
                  options={{ tooltip: false }}
                />
              </Flex>
            </Flex>
          }
          field="total_staked"
          data={data}
          options={{ valueFontSize: '5', notation: 'compact' }}
        />
      </LinkWrapper>
    );
  }

  return <KpiSkeleton />;
}
